import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { notificationLabel, notificationColor } from '../messages/NotificationStatusChip';

const humanDateTime = (value) => value ? new Date(value).toLocaleString('tr-TR') : '-';

export const formatSendStats = (stats) => {
  const processed = Number(stats?.processed_students ?? stats?.sent ?? 0);
  const queued = Number(stats?.queued || 0);
  const skipped = Number(stats?.skipped || 0);
  const parts = [`${processed} öğrenci işlendi`, `${queued} mesaj kuyruğa eklendi`];
  if (skipped > 0) parts.push(`${skipped} atlandı`);
  return parts.join(' • ');
};

const stageLabel = (title, status, requestedAt) =>
  `${title}: ${status ? notificationLabel(status) : requestedAt ? 'Paylaşım başlatılmış; durum kaydı yok' : 'Paylaşım bekliyor'}`;

export default function ExamCommunicationStatusPanel({ item }) {
  if (!item) return null;
  const reminderLabel = item.reminder_message_status || item.reminder_last_sent_at
    ? stageLabel('Hatırlatma', item.reminder_message_status, item.reminder_last_sent_at)
    : !item.reminder_enabled
      ? 'Hatırlatma kapalı'
      : item.reminder_scheduled_for
        ? `Hatırlatma planlandı • ${humanDateTime(item.reminder_scheduled_for)}`
        : 'Hatırlatma tarihi yok';
  return (
    <Stack spacing={1} sx={{ p: 1.5, borderRadius: 2, bgcolor: 'rgba(15, 23, 42, 0.03)' }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>İletişim durumu</Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Chip size="small" color={notificationColor(item.plan_message_status)}
          label={stageLabel('Plan', item.plan_message_status, item.plan_message_last_sent_at)} />
        <Chip size="small" color={notificationColor(item.reminder_message_status)} label={reminderLabel} />
        <Chip size="small" color={notificationColor(item.result_message_status)}
          label={stageLabel('Sonuç', item.result_message_status, item.result_message_last_sent_at)} />
      </Stack>
      <Typography variant="caption" color="text.secondary">Gönderildi: WhatsApp gönderimi kabul etti; teslim veya okunma bilgisi değildir.</Typography>
    </Stack>
  );
}
